module.exports = __webpack_public_path__ + "img/9788936433635.4de68b82.jpg";